import type { SpaceKind } from '@sivan/shared';
import { ROW_STATE_LABELS } from './labels';
import { type SpaceRow, spaceDraft as draft } from './space-draft';
import { Value } from './Value';

interface SpaceCardsProps {
  readonly rows: readonly SpaceRow[];
  readonly kind: SpaceKind;
  readonly canEdit: boolean;
  readonly onEdit: (row: SpaceRow) => void;
}

/** Phone layout: one card per space, with its location and apartment. Editing opens a form. */
export function SpaceCards({ rows, kind, canEdit, onEdit }: SpaceCardsProps) {
  const one = kind === 'parking' ? 'חניה' : 'מחסן';
  return (
    <ul className="unit-cards" aria-label={kind === 'parking' ? 'רשימת חניות' : 'רשימת מחסנים'}>
      {rows
        .filter((row) => draft.rowState(row) !== 'placeholder')
        .map((row) => {
          const state = draft.rowState(row);
          const error = Object.keys(row.errors).length > 0;
          const number = draft.displayValue(row, 'number');
          const apartment = draft.displayValue(row, 'apartment');
          return (
            <li key={row.key} className={`unit-card unit-card--${error ? 'error' : state}`}>
              <div className="unit-card__head">
                <strong>
                  {one} <Value text={number || '—'} />
                </strong>
                <span className={`chip chip--${error ? 'error' : state}`}>
                  {error ? 'שגיאה' : ROW_STATE_LABELS[state]}
                </span>
              </div>
              <dl className="unit-card__facts">
                <div>
                  <dt>{kind === 'parking' ? 'חניון' : 'מבנה'}</dt>
                  <dd>
                    <Value text={draft.displayValue(row, 'location') || '—'} />
                  </dd>
                </div>
                <div>
                  <dt>מרתף</dt>
                  <dd>
                    <Value text={draft.displayValue(row, 'level') || '—'} />
                  </dd>
                </div>
                <div>
                  <dt>מוצמד/ת לדירה</dt>
                  <dd>
                    {apartment === '' ? (
                      'פנוי/ה'
                    ) : (
                      <>
                        בנין <Value text={draft.displayValue(row, 'building')} /> · דירה{' '}
                        <Value text={apartment} />
                      </>
                    )}
                  </dd>
                </div>
              </dl>
              {canEdit && (
                <button
                  type="button"
                  className="button button--small"
                  onClick={() => {
                    onEdit(row);
                  }}
                >
                  עריכה
                  <span className="visually-hidden">
                    {' '}
                    של {one} {number}
                  </span>
                </button>
              )}
            </li>
          );
        })}
    </ul>
  );
}
